<template>
  <el-dialog width="500px" :visible.sync="dialogVisible" :close-on-click-modal="false" destroy-on-close>
    <div slot="title">
      {{ $t('customer::customers-notice::send_email')}}
    </div>
    <p style="margin-bottom:10px;">{{ $t('customer::customers-notice::email_send_to')}} {{ count.label }} {{ $t('customer::customers-notice::user') }} （ {{ $t('customer::customers-notice::total') }}{{ count.num }}{{ $t('customer::customers-notice::single') }}）</p>
    <template v-if="params.delayToSendDate">
      <el-form label-position="right" v-if="checkDelay">
        <el-form-item :label="$t('customer::customers-notice::send_time')" prop="sendTime">
          <el-date-picker
            v-model="date"
            type="date"
            :placeholder="$t('customer::customers-notice::select_long_date')"
            value-format="yyyy-MM-dd"
            style="width: 160px;"
            :picker-options="pickerDate"
          ></el-date-picker>
          <el-time-select
            v-model="time"
            :picker-options="pickerTime"
            :placeholder="$t('customer::customers-notice::select_time')"
            style="width: 160px;"
          ></el-time-select>
          <p v-show="checkDelay" style="color:#d9001b;">{{ $t('customer::customers-notice::over_time') }}</p>
        </el-form-item>
      </el-form>
      <p v-else>{{ $t('customer::customers-notice::send_time') }}： {{ date }} {{ time }}</p>
    </template>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="medium">{{ $t('customer::customers-notice::cancel') }}</el-button>
      <el-button type="primary" size="medium" @click="submitForm" :loading="submitLoading">{{ $t('customer::customers-notice::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import { addEmailModule, getEmailDetail, updateSendEmailModule, getSendCountAndType } from '@/server/customers'
export default {
  props: {
    value: {},
    emailModel: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      pickerDate: {
        disabledDate: time => {
          return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000
        }
      },
      dialogVisible: this.value,
      time: '',
      date: '',
      params: {},
      rules: {},
      count: { label: '', num: 0 },
      submitLoading: false,
      labelStatus: {
        1: $t('customer::customers-notice::level'),
        2: $t('customer::customers-notice::tag'),
        3: $t('customer::customers-notice::count')
      },
      stepStauts: {
        0: $t('customer::customers-notice::zero_time'),
        1: $t('customer::customers-notice::one_time'),
        2: $t('customer::customers-notice::over_one_time'),
        3: $t('customer::customers-notice::second_time')
      }
    }
  },
  computed: {
    pickerTime() {
      let start = ''
      if (moment().format('mm') > 30) {
        start = `${Number(moment().format('HH')) + 1}:00`
      } else if (moment().format('mm') < 30 && moment().format('mm') > 0) {
        start = `${moment().format('HH')}:30`
      } else {
        start = moment().format('HH:mm')
      }
      if (this.date === moment().format('YYYY-MM-DD')) {
        return {
          start: start,
          step: '00:30',
          end: '24:00'
        }
      } else {
        return {
          start: '00:00',
          step: '00:30',
          end: '24:00'
        }
      }
    },
    // 判断草稿的发送时间是否已过时
    checkDelay() {
      return this.params.delayToSendDate && new Date(this.params.delayToSendDate).getTime() < Date.now()
    }
  },
  watch: {
    value(val) {
      this.dialogVisible = val
      if (val) {
        this.params = { ...this.emailModel }
        if (this.params.delayToSendDate) {
          this.date = this.params.delayToSendDate.split(' ')[0]
          this.time = this.params.delayToSendDate.split(' ')[1]
        }
        this.getSendCountAndType(this.params)
      } else {
        this.params = {}
      }
    },
    dialogVisible(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    submitForm() {
      if (this.checkDelay) {
        // 判断是否超时
        if (new Date(this.date + ' ' + this.time).getTime() < Date.now()) {
          return
        } else {
          if (this.emailModel.id) {
            this.update({ ...this.emailModel, delayToSendDate: this.date + ' ' + this.time + ':00' })
          } else {
            this.send({ ...this.emailModel, delayToSendDate: this.date + ' ' + this.time + ':00' })
          }
        }
      } else {
        if (this.emailModel.id) {
          // 判断新增还是保存
          this.update(this.emailModel)
        } else {
          this.send(this.emailModel)
        }
      }
    },
    // 新增发送模板
    async send(obj) {
      this.submitLoading = true
      const { data } = await addEmailModule(obj)
      let id = null
      if (data.code === this.$code) {
        if (obj.delayToSendDate) {
          this.$message.success($t('customer::customers-notice::arrange_send'))
        } else {
          this.$message.warning($t('customer::customers-notice::sending_now'))
          // this.getEmailDetail(data.data.id)
          id = data.data.id
        }
        this.$emit('save', id)
      }
      this.submitLoading = false
    },
    async update(obj) {
      this.submitLoading = true
      const { data } = await updateSendEmailModule(obj)
      let id = null
      if (data.code === this.$code) {
        if (obj.delayToSendDate) {
          this.$message.success($t('customer::customers-notice::arrange_send'))
        } else {
          this.$message.warning($t('customer::customers-notice::sending_now'))
          // this.getEmailDetail(obj.id)
          id = obj.id
        }
        this.$emit('save', id)
      }
      this.submitLoading = false
    },
    async getSendCountAndType(obj) {
      const { data } = await getSendCountAndType({ filter: obj.filter, filterValue: obj.filterValue })
      if (data.code === this.$code) {
        this.count.num = data.data.toCount
        this.count.label = this.checkReceiver(obj, data.data)
      }
    },
    checkReceiver(row, data) {
      console.log(row)
      if (row.filter === 0) {
        return $t('customer::customers-notice::all')
      } else if (row.filter === 3) {
        return this.labelStatus[row.filter] + ':' + this.stepStauts[row.filterValue] + $t('customer::customers-notice::de')
      } else {
        return this.labelStatus[row.filter] + ':' + data.filterName + $t('customer::customers-notice::de')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    max-height: 550px;
    overflow-y: auto;
  }
}
</style>
